import { WithdrawalsLimitsRecord } from '@types';

import { WithdrawalsSetLimitsAggregatorReducer } from './types';

export const withdrawalsSetLimitsAggregatorReducer: WithdrawalsSetLimitsAggregatorReducer =
  (state, action) => {
    const { limitId, aggregatorId } = action.payload;

    const updatedItem: WithdrawalsLimitsRecord = {
      [limitId]: {
        ...(state.withdrawalsLimitsProcessedItems?.[limitId] ?? {
          currency: undefined,
          minAmount: undefined,
          maxAmount: undefined,
          limitType: undefined,
        }),
        aggregatorId,
      },
    };

    return {
      ...state,
      withdrawalsLimitsProcessedItems: {
        ...state.withdrawalsLimitsProcessedItems,
        ...updatedItem,
      },
    };
  };
